export function queryPlayDom(root = document) {
  return {
  app: root.querySelector(".app"),
  sidebar: root.querySelector(".sidebar"),
  sidebarToggle: root.getElementById("sidebar-toggle"),
  mobileChatToggle: root.getElementById("mobile-chat-toggle"),
  mobileJoystickZone: root.getElementById("mobile-joystick-zone"),
  mobileCinemaStand: root.getElementById("mobile-cinema-stand"),
  mobileStuckButton: root.getElementById("mobile-stuck-button"),
  mobileForkDown: root.getElementById("mobile-fork-down"),
  mobileForkUp: root.getElementById("mobile-fork-up"),
  mobileForkliftExit: root.getElementById("mobile-forklift-exit"),
  mobileCutsceneForward: root.getElementById("mobile-cutscene-forward"),
  mobileCutsceneSkip: root.getElementById("mobile-cutscene-skip"),
  mobileArcadeStick: root.getElementById("mobile-arcade-stick"),
  mobileArcadeButtons: [
    ...root.querySelectorAll("[data-arcade-control]"),
  ],
  canvas: root.getElementById("renderCanvas"),
  dialogueOverlay: root.getElementById("dialogue-overlay"),
  dialogueSpeaker: root.getElementById("dialogue-speaker"),
  dialogueSource: root.getElementById("dialogue-source"),
  dialogueJapanese: root.getElementById("dialogue-japanese"),
  dialogueOptions: root.getElementById("dialogue-options"),
  loading: root.getElementById("loading"),
  loadingPlaceJapanese: root.getElementById("loading-place-japanese"),
  transitionFrame: root.getElementById("transition-frame"),
  loadingPlaceEnglish: root.getElementById("loading-place-english"),
  loadingTime: root.getElementById("loading-time"),
  loadingDate: root.getElementById("loading-date"),
  status: root.getElementById("status"),
  loadingProgress: root.getElementById("loading-progress"),
  loadingWord: root.getElementById("loading-word"),
  loadingDots: root.getElementById("loading-dots"),
  loadingCount: root.getElementById("loading-count"),
  loadingError: root.getElementById("loading-error"),
  settingsButton: root.getElementById("settings-button"),
  logoutButton: root.getElementById("logout-button"),
  journalButton: root.getElementById("journal-button"),
  inventoryButton: root.getElementById("inventory-button"),
  bigChat: root.getElementById("big-chat"),
  hideControls: root.getElementById("hide-controls"),
  hideDiscord: root.getElementById("hide-discord"),
  showDebug: root.getElementById("show-debug"),
  debugVisibilityOption: root.getElementById("debug-visibility-option"),
  musicControls: root.getElementById("music-controls"),
  overallVolume: root.getElementById("overall-volume"),
  musicVolume: root.getElementById("music-volume"),
  musicMuted: root.getElementById("music-muted"),
  dialogueVolume: root.getElementById("dialogue-volume"),
  dialogueMuted: root.getElementById("dialogue-muted"),
  ambientVolume: root.getElementById("ambient-volume"),
  ambientMuted: root.getElementById("ambient-muted"),
  soundEffectsVolume: root.getElementById("sound-effects-volume"),
  soundEffectsMuted: root.getElementById("sound-effects-muted"),
  footstepsMuted: root.getElementById("footsteps-muted"),
  forkliftReverseMuted: root.getElementById("forklift-reverse-muted"),
  muteAll: root.getElementById("mute-all"),
  arcadeBgVolumeRow: root.getElementById("arcade-bg-volume-row"),
  arcadeBgVolume: root.getElementById("arcade-bg-volume"),
  arcadeBgMutedRow: root.getElementById("arcade-bg-muted-row"),
  arcadeBgMuted: root.getElementById("arcade-bg-muted"),
  tvVolume: root.getElementById("tv-volume"),
  tvMuted: root.getElementById("tv-muted"),
  runState: root.getElementById("run-state"),
  autoRunState: root.getElementById("auto-run-state"),
  noClipState: root.getElementById("no-clip-state"),
  noClipControlRow: root.getElementById("no-clip-control-row"),
  movementControlLabel: root.getElementById("movement-control-label"),
  runControlKey: root.getElementById("run-control-key"),
  autoRunControlRow: root.getElementById("auto-run-control-row"),
  cameraModeControlRow: root.getElementById(
    "camera-mode-control-row",
  ),
  zoomControlRow: root.getElementById("zoom-control-row"),
  lookControlKey: root.getElementById("look-control-key"),
  forkliftExitControlRow: root.getElementById(
    "forklift-exit-control-row",
  ),
  exitControlLabel: root.getElementById("exit-control-label"),
  worldCoordinates: root.getElementById("world-coordinates"),
  copyWorldCoordinates: root.getElementById("copy-world-coordinates"),
  worldFacing: root.getElementById("world-facing"),
  copyWorldFacing: root.getElementById("copy-world-facing"),
  stuckHint: root.getElementById("stuck-hint"),
  transientNotice: root.getElementById("transient-notice"),
  forkliftTipHint: root.getElementById("forklift-tip-hint"),
  inspectHint: root.getElementById("inspect-hint"),
  vendingOverlay: root.getElementById("vending-overlay"),
  vendingOptions: root.getElementById("vending-options"),
  vendingPrice: root.getElementById("vending-price"),
  vendingStatus: root.getElementById("vending-status"),
  vendingClose: root.getElementById("vending-close"),
  arcadeOverlay: root.getElementById("arcade-overlay"),
  arcadeShell: root.getElementById("arcade-shell"),
  arcadeCanvas: root.getElementById("arcade-canvas"),
  arcadeTitle: root.getElementById("arcade-title"),
  arcadeInstructions: root.getElementById("arcade-instructions"),
  arcadeScore: root.getElementById("arcade-score"),
  arcadeHighScore: root.getElementById("arcade-high-score"),
  arcadeStatus: root.getElementById("arcade-status"),
  arcadeClose: root.getElementById("arcade-close"),
  arcadeEmulatorFrame: root.getElementById("arcade-emulator-frame"),
  worldControlsHud: root.getElementById("world-controls-hud"),
  arcadeControlsHud: root.getElementById("arcade-controls-hud"),
  poolControlsHud: root.getElementById("pool-controls-hud"),
  dialogueControlsHud: root.getElementById("dialogue-controls-hud"),
  raceHud: root.getElementById("race-hud"),
  raceStart: root.getElementById("race-start"),
  raceTiming: root.getElementById("race-timing"),
  raceState: root.getElementById("race-state"),
  raceTimer: root.getElementById("race-timer"),
  raceBest: root.getElementById("race-best"),
  raceCheckpoints: root.getElementById("race-checkpoints"),
  raceRestart: root.getElementById("race-restart"),
  raceQuit: root.getElementById("race-quit"),
  raceCountdown: root.getElementById("race-countdown"),
  debugPanel: root.getElementById("debug-panel"),
  debugArcadeMode: root.getElementById("debug-arcade-mode"),
  debugArcadeFps: root.getElementById("debug-arcade-fps"),
  debugArcadeVideos: root.getElementById("debug-arcade-videos"),
  debugArcadeLights: root.getElementById("debug-arcade-lights"),
  debugArcadeScreens: root.getElementById("debug-arcade-screens"),
  debugArcadeReason: root.getElementById("debug-arcade-reason"),
  debugScriptScenario: root.getElementById("debug-script-scenario"),
  debugApplyScriptScenario: root.getElementById(
    "debug-apply-script-scenario",
  ),
  debugResetScriptScenario: root.getElementById(
    "debug-reset-script-scenario",
  ),
  debugScriptScenarioStatus: root.getElementById(
    "debug-script-scenario-status",
  ),
  debugCutsceneTransport: root.getElementById("debug-cutscene-transport"),
  debugCutscenePosition: root.getElementById("debug-cutscene-position"),
  debugCutsceneBack60: root.getElementById("debug-cutscene-back-60"),
  debugCutsceneBack15: root.getElementById("debug-cutscene-back-15"),
  debugCutsceneBack: root.getElementById("debug-cutscene-back"),
  debugCutscenePause: root.getElementById("debug-cutscene-pause"),
  debugCutsceneForward: root.getElementById("debug-cutscene-forward"),
  debugCutsceneForward15: root.getElementById("debug-cutscene-forward-15"),
  debugCutsceneForward60: root.getElementById("debug-cutscene-forward-60"),
  debugNpcSelection: root.getElementById("debug-npc-selection"),
  debugNpcName: root.getElementById("debug-npc-name"),
  debugNpcId: root.getElementById("debug-npc-id"),
  showCollisions: root.getElementById("show-collisions"),
  showLights: root.getElementById("show-lights"),
  showLightsLabel: root.getElementById("show-lights-label"),
  lightDebugEditor: root.getElementById("light-debug-editor"),
  lightDebugName: root.getElementById("light-debug-name"),
  lightDebugIntensity: root.getElementById("light-debug-intensity"),
  lightDebugIntensityValue: root.getElementById(
    "light-debug-intensity-value",
  ),
  lightDebugRange: root.getElementById("light-debug-range"),
  lightDebugRangeValue: root.getElementById("light-debug-range-value"),
  lightDebugAngle: root.getElementById("light-debug-angle"),
  lightDebugAngleValue: root.getElementById("light-debug-angle-value"),
  lightDebugAngleField: root.getElementById("light-debug-angle-field"),
  lightDebugExponent: root.getElementById("light-debug-exponent"),
  lightDebugExponentValue: root.getElementById(
    "light-debug-exponent-value",
  ),
  lightDebugExponentField: root.getElementById(
    "light-debug-exponent-field",
  ),
  lightDebugPositionX: root.getElementById("light-debug-position-x"),
  lightDebugPositionXValue: root.getElementById(
    "light-debug-position-x-value",
  ),
  lightDebugPositionXField: root.getElementById(
    "light-debug-position-x-field",
  ),
  lightDebugPositionY: root.getElementById("light-debug-position-y"),
  lightDebugPositionYValue: root.getElementById(
    "light-debug-position-y-value",
  ),
  lightDebugPositionYField: root.getElementById(
    "light-debug-position-y-field",
  ),
  lightDebugPositionZ: root.getElementById("light-debug-position-z"),
  lightDebugPositionZValue: root.getElementById(
    "light-debug-position-z-value",
  ),
  lightDebugPositionZField: root.getElementById(
    "light-debug-position-z-field",
  ),
  lightDebugDirectionX: root.getElementById("light-debug-direction-x"),
  lightDebugDirectionXValue: root.getElementById(
    "light-debug-direction-x-value",
  ),
  lightDebugDirectionXField: root.getElementById(
    "light-debug-direction-x-field",
  ),
  lightDebugDirectionY: root.getElementById("light-debug-direction-y"),
  lightDebugDirectionYValue: root.getElementById(
    "light-debug-direction-y-value",
  ),
  lightDebugDirectionYField: root.getElementById(
    "light-debug-direction-y-field",
  ),
  lightDebugDirectionZ: root.getElementById("light-debug-direction-z"),
  lightDebugDirectionZValue: root.getElementById(
    "light-debug-direction-z-value",
  ),
  lightDebugDirectionZField: root.getElementById(
    "light-debug-direction-z-field",
  ),
  copyLightDebug: root.getElementById("copy-light-debug"),
  tintCollisions: root.getElementById("tint-collisions"),
  trianglePicker: root.getElementById("triangle-picker"),
  copyTriangleSelection: root.getElementById(
    "copy-triangle-selection",
  ),
  collisionPicker: root.getElementById("collision-picker"),
  copyCollisionSelection: root.getElementById(
    "copy-collision-selection",
  ),
  downloadPoolReflection: root.getElementById(
    "download-pool-reflection",
  ),
  debugTimeOfDay: root.getElementById("debug-time-of-day"),
  debugTimeOfDayValue: root.getElementById("debug-time-of-day-value"),
  debugLiveClock: root.getElementById("debug-live-clock"),
  debugRunSpeed: root.getElementById("debug-run-speed"),
  debugRunSpeedValue: root.getElementById("debug-run-speed-value"),
  debugNpcWalkSpeed: root.getElementById("debug-npc-walk-speed"),
  debugNpcWalkSpeedValue: root.getElementById(
    "debug-npc-walk-speed-value",
  ),
  debugNpcWalkSpeedReset: root.getElementById(
    "debug-npc-walk-speed-reset",
  ),
  forkliftComHeight: root.getElementById("forklift-com-height"),
  forkliftComHeightValue: root.getElementById(
    "forklift-com-height-value",
  ),
  forkliftSpringRate: root.getElementById("forklift-spring-rate"),
  forkliftSpringRateValue: root.getElementById(
    "forklift-spring-rate-value",
  ),
  forkliftShockDamping: root.getElementById("forklift-shock-damping"),
  forkliftShockDampingValue: root.getElementById(
    "forklift-shock-damping-value",
  ),
  forkliftLoadInfluence: root.getElementById(
    "forklift-load-influence",
  ),
  forkliftLoadInfluenceValue: root.getElementById(
    "forklift-load-influence-value",
  ),
  forkliftTireGrip: root.getElementById("forklift-tire-grip"),
  forkliftTireGripValue: root.getElementById(
    "forklift-tire-grip-value",
  ),
  forkliftBrakeForce: root.getElementById("forklift-brake-force"),
  forkliftBrakeForceValue: root.getElementById(
    "forklift-brake-force-value",
  ),
  forkliftDriveForce: root.getElementById("forklift-drive-force"),
  forkliftDriveForceValue: root.getElementById(
    "forklift-drive-force-value",
  ),
  forkliftSteeringResponse: root.getElementById(
    "forklift-steering-response",
  ),
  forkliftSteeringResponseValue: root.getElementById(
    "forklift-steering-response-value",
  ),
  forkliftHighSpeedSteering: root.getElementById(
    "forklift-high-speed-steering",
  ),
  forkliftHighSpeedSteeringValue: root.getElementById(
    "forklift-high-speed-steering-value",
  ),
  forkliftRollStiffness: root.getElementById("forklift-roll-stiffness"),
  forkliftRollStiffnessValue: root.getElementById(
    "forklift-roll-stiffness-value",
  ),
  chatPanel: root.getElementById("chat-panel"),
  chatInput: root.getElementById("chat-input"),
  combatHud: root.getElementById("combat-hud"),
  combatCommandFeedback: root.getElementById("combat-command-feedback"),
  combatCommandKeys: root.getElementById("combat-command-keys"),
  combatCommandMove: root.getElementById("combat-command-move"),
  combatCommandResult: root.getElementById("combat-command-result"),
  combatPlayerGauge: root.getElementById("combat-player-gauge"),
  combatEnemyGauge: root.getElementById("combat-enemy-gauge"),
  combatMoveCount: root.getElementById("combat-move-count"),
  combatMoveList: root.getElementById("combat-move-list"),
  combatModeControlLabel: root.getElementById("combat-mode-control-label"),
  };
}
